import { useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'
import { SearchList01Icon } from '@hugeicons/core-solid-rounded'
import { useLingui } from '@lingui/react/macro'

import FilterSelect from '@/components/ui/FilterSelect'
import Input from '@/components/ui/Input'
import { GoodieTable } from '@/features/goodies'
import { useGoodieTable } from '@/features/goodies'
import { useGoodieTypeOptions } from '../utils/helpers'

export default function SelectGoodie({
  onSelectedGoodie
}: {
  onSelectedGoodie: (goodie: GraphQL.GoodieFragmentFragment) => void
}) {
  const { t } = useLingui()
  const typeOptions = useGoodieTypeOptions()

  const possibleTypes = useMemo(
    () => typeOptions.map(({ value }) => value),
    [typeOptions]
  )

  const { queryVariables, types, search, setSearch, setTypes, updateSort } =
    useGoodieTable(possibleTypes)

  return (
    <div className="flex flex-col gap-5">
      <div className="flex w-full flex-row gap-2.5 pb-6">
        <FilterSelect
          options={typeOptions}
          selectedValues={types}
          onChange={setTypes}
          placeholder={t`All types`}
        />
        <Input
          Icon={SearchList01Icon}
          placeholder={t`Search…`}
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
      </div>
      <GoodieTable
        selectedIds={new Set()}
        onSelect={onSelectedGoodie}
        variables={queryVariables}
        onChangeSort={updateSort}
        hideButtons
        hideCheckbox
        shouldSelectInsteadOfEdit
      />
    </div>
  )
}
